module.exports = __webpack_public_path__ + "static/HomePageBackGround-ca7909a05b3e34d038c9d69e6ea029ea.png";